import React, { useRef, useContext, useEffect } from 'react';
import Navigation from './EditorNavigation';
import Thumbnail from './EditorThumbnail';
import Tools from './EditorTools';
import View from './EditorViewer';
import Tour from './EditorTour';
import '../styles/Editor.styles.scss';
import useToggle from '../hooks/useToggle';
import EditorContext from '../store/Editor.context';
import OptionsContext from '../store/Options.context';
import { STORAGE } from '../constants';

var Editor = function Editor(_ref) {
  var onRedactSuccess = _ref.onRedactSuccess,
      onExtiredSession = _ref.onExtiredSession,
      onCancel = _ref.onCancel;

  var _useContext = useContext(EditorContext),
      state = _useContext.state;

  var _useToggle = useToggle(false),
      isTourOpen = _useToggle[0],
      toggleIsTourOpen = _useToggle[1];

  var thumbnailref = useRef(null);
  useEffect(function () {
    if (state.mounted) {
      var isOpen = JSON.parse(localStorage.getItem(STORAGE.isOpenTour));
      toggleIsTourOpen(isOpen);
      localStorage.setItem(STORAGE.isOpenTour, false);
    }
  }, [state.mounted]);
  var refPdf = useRef(null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OptionsContext.Provider, {
    value: {
      onRedactSuccess: onRedactSuccess,
      onExtiredSession: onExtiredSession,
      onCancel: onCancel
    }
  }, /*#__PURE__*/React.createElement(Tour, {
    isTourOpen: isTourOpen,
    toggleIsTourOpen: toggleIsTourOpen
  }), /*#__PURE__*/React.createElement("div", {
    id: "pdf-editor",
    className: "pdf-editor relative min-h-screen flex flex-col"
  }, /*#__PURE__*/React.createElement(Navigation, {
    refPdf: refPdf
  }), /*#__PURE__*/React.createElement("div", {
    className: "pdf-content flex-grow w-full flex"
  }, state.thumbnail && /*#__PURE__*/React.createElement(Thumbnail, {
    ref: thumbnailref
  }), /*#__PURE__*/React.createElement(View, {
    ref: refPdf,
    thumbnailref: thumbnailref
  }), state.tools && /*#__PURE__*/React.createElement(Tools, {
    isTour: isTourOpen,
    toggleIsTour: toggleIsTourOpen
  })))));
};

export default Editor;